import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';

import { connect } from 'shalala';
import { useStore } from '../../store';
import { Auth, Http } from '../../support';
import Loading from '../../facturotopia/loading/Loading';
import LoadingButton from '../../facturotopia/LoadingButton';
import PageHeader from '../../support/page-header/PageHeader';
import { Col, Row, Card, Badge, Button } from 'react-bootstrap';
import ResponseError from '../../shared/responses/ResponseError';
import ResponseResult from '../../shared/responses/ResponseResult';
import TransferInformation from '../comprar/hits/components/TransferInformation';
// import RequestSalesInvoiceActions from './components/RequestSalesInvoiceActions';
import ComprobantesDownloadItemActions from './components/ComprobantesDownloadItemActions';

class ShoppingHistoryInfo extends Component {

  state = {}

  constructor(props) {
    super(props);

    const { cliente } = Auth.getData();

    const { data = {}} = props.location.state || {};
    const { id } = this.props.match.params;

    this.state = {
      data: !!data.id ? { ...data } : { id },
      cliente
    };

    props.setData(this.state.data);
  }

  componentDidMount() {
    const { data } = this.state;

    if (!data.descripcion) {
      this.props.history.replace('/cuenta/historial-compra');
    }

    this.props.get(data.id);
  }

  handleOnPaymentRetry = () => {
    this.props.history.push({
      pathname: `/cuenta/comprar/${this.state.data.id}/landing`,
      search: '?retry=1'
    });
  }

  handleOnCardChange = () => {
    const { data } = this.props;

    this.props.history.push({
      pathname: `/cuenta/paquetes/${data.paquete_id}`,
    });
  }

  handleOnCardPayemntChange = () => {
    const { data } = this.props;

    const search = data.esquema === 'postpago' ? 'esquema=postpago' : '';

    this.props.history.push({
      pathname: `/cuenta/comprar/${data.id}/landing`,
      search: search
    });
  }

  handleOnCreateRefund = async () => {
    const { id } = this.props.match.params;

    this.setState({
      busyRefund: true,
    });

    const params = {};

    try {
      const response = await Http.patch(`api/compras/${id}/reembolso`, params);

      this.setState({
        result: response
      });

    } catch (response) {
      this.setState({
        error: response.data || response
      });
    } finally {
      this.setState({
        busyRefund: false
      });
    }
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  renderResult = () => {
    const { result } = this.state;

    return (
      <div className="result-container">
        <ResponseResult
          title="Completado"
          result={ result }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  handleOnAction = async (action) => {
    if (action === 'reset') {
      this.setState({
        error: undefined,
      });
    }

    if (action === 'success') {
      this.setState({
        result: undefined,
      });

      this.props.get(this.state.data.id);
    }
  }

  renderButtonConfirmTransfer = ({ status, id}) => {
    const query = this.props.location.search || '';

    return (
      Guardian.allows('root.access') && status !== '1' && (
        <Link to={ `/cuenta/historial-compra/${id}/confirm${query}` } className="mr-3">
          <Button type="button"
            variant="secondary"
          >
          Confirmar pago
        </Button>
      </Link>
      )
    )
  }

  renderDetallesPago = (data) => {
    const { metadata } = data;
    const { transfer = {} } = metadata;
    const { fecha, banco, numero_autorizacion } = transfer;

    return (
      <>
        <div className="d-block mt-3 mb-2">
          <strong className="text-muted">Tu pago</strong>
        </div>

        <Card>
          <Card.Body>
            <strong className="text-info card-label-info">Fecha operación: </strong>
            { fecha }
            <br/>

            <strong className="text-info card-label-info">Banco: </strong>
            { banco }
            <br/>

            <strong className="text-info card-label-info">Autorización: </strong>
            { numero_autorizacion }
            <br/>
          </Card.Body>
        </Card>
      </>
    )

  }

  render() {
    const { result, error, busyRefund, cliente } = this.state;
    const { data = {}, busy } = this.props;

    const uuids = [data.cfdi_uuid, data.cfdi_uuid_pago].filter(function (uuid) {
      return uuid !== null
    })

    if (!!busy) {
      return <Loading className="text-info pl-3" />;
    }

    return (
      <>
        <PageHeader text="Mi consumo" to="/cuenta/historial-compra" />

        { !!error && this.renderError() }

        { !!result && this.renderResult() }

        { (!!data.cfdi_uuid || !!data.cfdi_uuid_pago) && (
          <div className="text-right mb-2 ">
            <ComprobantesDownloadItemActions data={ { uuids: uuids, id: data.id } } />
          </div>
        )}

        <Row>
          <Col>
            <h5>{ data.descripcion }</h5>
          </Col>
        </Row>

        <Row>
          <Col>
            { status(data) }
          </Col>
        </Row>

        <Row className="mt-1">
          <Col>
            <span className="text-muted">{ data.razon_status }</span>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col>
            <>
              { (data.status !== 1 && data.status !== 4) && data.gateway !== 'transfer' && data.esquema !== 'postpago' && (
                <>
                  <Button type="button"
                    className="mr-2"
                    variant="secondary"
                    onClick={ this.handleOnPaymentRetry }
                  >
                    Reintentar pago
                  </Button>

                  <Button type="button"
                    className="mr-2"
                    variant="secondary"
                    onClick={ this.handleOnCardChange }
                  >
                    Pagar con otra tarjeta
                  </Button>
                </>
              )}

              { data.status === 0 && !!cliente?.metadata?.stripe?.pm_id && (
                <Button type="button"
                  className="mr-2"
                  variant="secondary"
                  onClick={ this.handleOnCardPayemntChange }
                >
                  Pago con tarjeta
                </Button>
              )}

              { data.status !== 1 && data.gateway === 'transfer' && this.renderButtonConfirmTransfer(data) }

              { Guardian.allows('root.access') && data.status === 1 && data.gateway !== 'transfer' && (
                <LoadingButton type="button"
                  variant="secondary"
                  loading={ busyRefund }
                  disabled={ busyRefund }
                  onClick={ this.handleOnCreateRefund }
                >
                  { busyRefund && 'Procesando...'}
                  { !busyRefund && ' Solicitar reembolso' }
                </LoadingButton>
              )}
            </>
          </Col>
        </Row>

        { !!data && (
          <div>
            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Detalles</strong>
            </div>

            <Card>
              <Card.Body>
                <strong className="text-info card-label-info">Fecha: </strong>
                { data.updated_at }
                <br/>

                <strong className="text-info card-label-info">Descripción: </strong>
                { data.descripcion }
                <br/>

                <strong className="text-info card-label-info">Hits: </strong>
                { data.hits === -1 ? 'Hits ilimitados' : data.hits }
                <br/>

                <strong className="text-info card-label-info">Licencia: </strong>
                { licencia(data) }
                <br/>

                <strong className="text-info card-label-info">Monto: </strong>
                { data.monto }
                <br/>

                <strong className="text-info card-label-info">Forma de pago: </strong>
                { formaPago(data) }
                <br/>
              </Card.Body>
            </Card>
          </div>
        )}

        { (!data.cfdi_uuid) && (
          <div className="mt-3 mb-2">
            {/* Descomentar si requieren funcionalidad */}
            {/* <RequestSalesInvoiceActions data={ { id: data.id } } /> */}
          </div>
        )}

        { data.status === 0 && data.gateway === 'transfer' && (
          <Row className="mt-3">
            <Col>
              <TransferInformation />
            </Col>
          </Row>
        )}

        { data.status === 1 && data.gateway === 'transfer' && this.renderDetallesPago(data)}
      </>
    );
  }
}

const licencia = (data) => {
  const { licencia } = data;

  let text = '';

  switch (licencia) {
    case 'y':
      text = 'Anual';
      break;

    case 'm':
      text = 'Mensual';
      break;

    default:
      break;
  }

  return <span>{ text }</span>
}

const status = (data) => {
  const { status } = data;

  let text = '';
  let variant = '';

  switch (status) {
    case 1:
      text = 'Pago exitoso';
      variant = 'success';
      break;

    case -1:
      text = 'Pago rechazado';
      variant = 'danger';
      break;

    case 0:
      text = 'Pago pendiente';
      variant = 'warning';
      break;

    case 2:
      text = 'Procesando';
      variant = 'warning';
      break;

    case 3:
      text = 'Autenticando';
      variant = 'warning';
      break;

    case 4:
      text = 'Reembolso';
      variant = 'warning';
      break;

    default:
      break;
  }

  return <Badge variant={ variant }>{ text }</Badge>
}

const formaPago = (data) => {
  const { gateway, forma_pago, metadata = {} } = data;
  const { payment = {} } = metadata;
  const { brand, last4 } = payment;

  let text = '';

  switch (gateway) {
    case 'stripe':
      text = brand && last4 && `${brand} ${last4}`;
      break;

    case 'transfer':
      text = forma_pago;
      break;

    default:
      break;
  }

  return <span className="text-upper">{ text }</span>
}

const mapState = (state) => {
  return state.cuenta.historial_compra.info;
}

const mapActions = (actions) => {
  return actions.cuenta.historial_compra.info;
}

export default connect(useStore, mapState, mapActions)(ShoppingHistoryInfo);
